const en_master_convertion = {
    "": "item conversion",
    add: "add item conversion",
    convertion_goods: "converted item",
    edit: "edit item conversion",
    goods: "item conversion",
    name: "conversion name",
    origin_goods: "source item",

    error: {
        convertion_goods: "Converted item cannot be empty.",
        convertion_goods_qty: "Converted item quantity cannot be empty.",
        create: "Failed to create conversion.",
        delete: "Failed to delete conversion.",
        edit: "Failed to update conversion.",
        name: "Conversion name cannot be empty.",
        origin_goods: "Source item cannot be empty.",
        origin_goods_qty: "Source item quantity cannot be empty.",
    },

    success: {
        create: "Conversion created successfully.",
        delete: "Conversion deleted successfully.",
        edit: "Conversion updated successfully.",
    }
}

export default en_master_convertion;